import { useState } from 'react';
import ReactPhoneNumberInput, { type Country } from 'react-phone-number-input';
import esLabels from 'react-phone-number-input/locale/es';
import ptLabels from 'react-phone-number-input/locale/pt';

import { Input } from '#/components/Input/Input';
import { ClientOnly } from '#/containers/ClientOnly';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';

import { PhoneInputHolder } from './PhoneInput.styled';

type Props = {
  qaId?: string;
  name?: string;
  className?: string;
  disabled?: boolean;
  initialValueFormat?: 'national' | undefined;
  placeholder?: string;
  onChange?: (value: string | undefined) => void;
  value?: string;
  id?: string;
  defaultCountry?: Country;
};

export function PhoneInput({
  qaId,
  className,
  name,
  disabled,
  placeholder,
  onChange,
  value,
  initialValueFormat,
  id,
  defaultCountry,
}: Props) {
  const { locale } = useI18n();

  const [internalValue, setInternalValue] = useState<string | undefined>(value);

  const handleChange = (newValue: string | undefined) => {
    setInternalValue(newValue);
    onChange?.(newValue ?? '');
  };

  return (
    <PhoneInputHolder className={className} data-qa-id={qaId}>
      <ClientOnly placeholder={<Input inputProps={{ name, type: 'tel' }} />}>
        <ReactPhoneNumberInput
          name={name}
          value={internalValue}
          disabled={disabled}
          placeholder={placeholder}
          onChange={handleChange}
          countrySelectProps={{ unicodeFlags: true }}
          defaultCountry={defaultCountry || 'US'}
          initialValueFormat={initialValueFormat}
          id={id}
          labels={(() => {
            if (locale === I18nLocale.ES) return esLabels;
            if (locale === I18nLocale.PT) return ptLabels;
          })()}
        />
      </ClientOnly>
    </PhoneInputHolder>
  );
}
